export default function () {
    let exportResolve, exportReject;

    const promise = new Promise((resolve, reject) => {
        exportResolve = resolve;
        exportReject = reject;
    });

    return {
        promise: promise,
        resolve: exportResolve,
        reject: exportReject
    };
};
